import useSWR from 'swr';

export const useDataFetch = <TData = unknown>(endpoint: string | null) => {
  const fetcher = async (endpoint: string) => {
    const response = await fetch(endpoint);
    if (response.ok) {
      const data = await response.json();
      return data as TData;
    } else {
      const data = await response.json();
      throw new Error(`Failed to fetch data: ${endpoint}. ${data}`);
    }
  };

  const { data, isLoading, error } = useSWR(endpoint, fetcher, {
    revalidateOnFocus: false,
    dedupingInterval: 60_000,
    keepPreviousData: true,
  });

  return {
    data,
    isLoading,
    error,
  };
};
